// extracted by mini-css-extract-plugin
export var dot = "add-meal-type-modal-module--dot--dlI9b";
export var form = "add-meal-type-modal-module--form--ZgctP";
export var inputSelect = "add-meal-type-modal-module--input-select--xE3bz";
export var loader = "add-meal-type-modal-module--loader--Vj+oc";
export var modal = "add-meal-type-modal-module--modal--tCqP7";
export var option = "add-meal-type-modal-module--option--melKG";
export var submitButton = "add-meal-type-modal-module--submit-button--wSRD6";